// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are redirected to the login page.
import React, { useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";
import { getUserData } from "./utils/FunctionHelpers";
import LoadingSpinner from "./components/LoadingSpinner";

const PrivateRoute = ({ component: Component, notAllowedRoles, allowedRoles, ...rest }) => {
  const [authState, setAuthState] = useState({
    isChecking: true,
    isAuthenticated: false,
    shouldRedirect: false,
    redirectPath: "/login"
  });

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("token");
      const isAuthenticated = token && token !== "undefined";

      if (!isAuthenticated) {
        if (token === "undefined") {
          localStorage.clear();
        }
        localStorage.setItem(
          "redirectUrl",
          window.location.pathname + window.location.search
        );
        setAuthState({
          isChecking: false,
          isAuthenticated: false,
          shouldRedirect: true,
          redirectPath: "/login"
        });
        return;
      }

      const userData = getUserData();
      if (!userData || !userData.role) {
        localStorage.clear();
        setAuthState({
          isChecking: false,
          isAuthenticated: false,
          shouldRedirect: true,
          redirectPath: "/login"
        });
        return;
      }

      const roles = userData.role;

      const hasRestrictedRole = notAllowedRoles?.some(role =>
        roles.includes(role)
      );

      const lacksRequiredRole = allowedRoles && !roles.some(role =>
        allowedRoles.includes(role)
      );

      const shouldRedirect = hasRestrictedRole || lacksRequiredRole;


      setAuthState({
        isChecking: false,
        isAuthenticated: true,
        shouldRedirect,
        redirectPath: hasRestrictedRole ? "/selections" : ""
      });
    };

    checkAuth();
  }, [notAllowedRoles, allowedRoles]);

  if (authState.isChecking) {
    return <LoadingSpinner />;
  }

  if (authState.shouldRedirect) {
    return <Redirect to={authState.redirectPath} />;
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default PrivateRoute;
